export enum MultiSignerSignState {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
  UNDECIDED = 'UNDECIDED',
}
